import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import api from "../api/api";

const DeliveryAllotment = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('username');
    navigate('/');
  };

  const getCurrentDate = () => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date().toLocaleDateString('en-US', options);
  };

  const getCurrentDateISO = () => {
    return new Date().toISOString().split('T')[0];
  };

  const [assignedBills, setAssignedBills] = useState({});
  const [summaryRows, setSummaryRows] = useState([]);
  const [filterDeliveryPerson, setFilterDeliveryPerson] = useState("");
  const [appliedFilterPerson, setAppliedFilterPerson] = useState("");
  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const [detailRows, setDetailRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [currentModalPerson, setCurrentModalPerson] = useState('');
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printPerson, setPrintPerson] = useState('');
  const [selectedDeliveryPerson, setSelectedDeliveryPerson] = useState("");
  const [appliedDeliveryPerson, setAppliedDeliveryPerson] = useState("");
  const [itemTypes, setItemTypes] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [selectedItemType, setSelectedItemType] = useState("");
  const [searchReportType, setSearchReportType] = useState("");
  const [searchItemType, setSearchItemType] = useState("");
  const [selectedReportType, setSelectedReportType] = useState("");

  const [activeIndexReportType, setActiveIndexReportType] = useState(-1);
  const [activeIndexItemType, setActiveIndexItemType] = useState(-1);
  const [activeIndexDeliveryPerson, setActiveIndexDeliveryPerson] = useState(-1);

const [deliverySearch, setDeliverySearch] = useState("");
const [showDpDropdown, setShowDpDropdown] = useState(false);

const [reportSearch, setReportSearch] = useState("");
const [showReportDropdown, setShowReportDropdown] = useState(false);

const [itemSearch, setItemSearch] = useState("");
const [showItemDropdown, setShowItemDropdown] = useState(false);

const listRefReportType = useRef(null);
const listRefItemType = useRef(null);
const listRefDeliveryPerson = useRef(null);

  const filteredRows = detailRows.filter(row => {
    const customer = row.customer || "";
    const invoice = row.invoice || "";

    const matchesSearch =
      customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.toString().includes(searchTerm);

    const matchesPerson =
      !appliedFilterPerson || row.deliveryPerson === appliedFilterPerson;

    return matchesSearch && matchesPerson;
  });

  const openBillModal = (personName) => {
    setCurrentModalPerson(personName);
    setModalOpen(true);
  };


  const exportToCSV = () => {
  if (!filteredRows || filteredRows.length === 0) {
    alert("No detail data to export");
    return;
  }

  const headers = [
    "Sl No",
    "Code",
    "Customer",
    "Invoice No",
    "Invoice Date",
    "Net Total",
    "C Balance",
    "Pay Mode",
    "Delivery Person",
  ];

  const rows = filteredRows.map((row, index) => [
    index + 1,
    row.code || "",
    row.customer || "",
    row.invoice || "",
    row.invDate || "",
    row.amount ?? 0,
    row.cBalance ?? 0,
    row.payMode || "",
    row.deliveryPerson || "",
  ]);

  const csvContent = [headers, ...rows]
    .map(r =>
      r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Delivery_Detail_List_${actionDate}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

  const closeBillModal = () => {
    setModalOpen(false);
  };

  const [detailLoading, setDetailLoading] = useState(false);
  const [actionDate, setActionDate] = useState(getCurrentDateISO());
  const formatAmount = (val) => {
    const num = Number(val);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  const reverseAssignment = (personName, billIndex) => {
    const bill = assignedBills[personName][billIndex];
    setAssignedBills(prev => {
      const newAssigned = { ...prev };
      newAssigned[personName] = newAssigned[personName].filter((_, i) => i !== billIndex);
      return newAssigned;
    });

    showToastMessage(`Reversed: ${bill.id} returned to detail list`);
  };

  const updateSummaryRow = (personName) => {
  };

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleRowCheckbox = (id, checked) => {
    setSelectedRows(prev => {
      const newSet = new Set(prev);
      if (checked) {
        newSet.add(id);
      } else {
        newSet.delete(id);
      }
      return newSet;
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRows(new Set(filteredRows.map(row => row.id)));
    } else {
      setSelectedRows(new Set());
    }
  };

  const handleDragStart = (e, row) => {
    let rowsToDrag = [];

    if (selectedRows.has(row.id)) {
      rowsToDrag = detailRows.filter(r => selectedRows.has(r.id));
    } else {
      rowsToDrag = [row];
      setSelectedRows(new Set([row.id]));
    }

    const payload = rowsToDrag.map(r => ({
      rowId: r.id,
      id: r.invoice,
      code: r.code,
      customer: r.customer,
      value: r.amount,
      prevDeliveryPerson: r.deliveryPerson
    }));

    e.dataTransfer.setData("application/json", JSON.stringify(payload));
  };

  useEffect(() => {
    fetchDeliverySheetItems();
  }, []);

  // Auto scroll for report type dropdown
  useEffect(() => {
    if (listRefReportType.current && activeIndexReportType >= 0) {
      const item = listRefReportType.current.children[activeIndexReportType];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexReportType]);

  // Auto scroll for item type dropdown
  useEffect(() => {
    if (listRefItemType.current && activeIndexItemType >= 0) {
      const item = listRefItemType.current.children[activeIndexItemType];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexItemType]);

  // Auto scroll for delivery person dropdown
  useEffect(() => {
    if (listRefDeliveryPerson.current && activeIndexDeliveryPerson >= 0) {
      const item = listRefDeliveryPerson.current.children[activeIndexDeliveryPerson];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexDeliveryPerson]);

  const username = sessionStorage.getItem("username") || "UnknownUser";

  const fetchDeliverySheetItems = async () => {
    try {
      const res = await api.DeliverySheetItemAPI(username);
      const data = res?.DeliverySheetItemAPIjs;
      setItemTypes(data?.Table || []);
      setReportTypes(data?.Table3 || []);
    } catch (err) {
      console.error("DeliverySheetItemAPI error:", err);
    }
  };

  const handleRefresh = async () => {
    if (!selectedItemType) {
      alert("Select Item Type");
      return;
    }

    const User = (username || "").toLowerCase();
    const ItemType = selectedItemType.toLowerCase();
    const Actiondate = actionDate;

    try {
      const res = await api.GetDeliveryItemAPI(User, ItemType, Actiondate);
      const apiData = res?.GetDeliveryItemAPIjs;

      setSummaryRows(apiData?.Table || []);
      setAssignedBills({});
      setSelectedRows(new Set());
      setDeliveryPersons(apiData?.Table2 || []);

    } catch (err) {
      console.error("GetDeliveryItemAPI error:", err);
    }
  };

  const handleDrop = async (e, targetPersonName) => {
    e.preventDefault();

    const items = JSON.parse(
      e.dataTransfer.getData("application/json")
    );
    if (!items || items.length === 0) return;

    const draggedIds = new Set(items.map(i => i.rowId));

    const targetDp = deliveryPersons.find(p => p.DpName === targetPersonName);
    if (!targetDp) {
      showToastMessage(`Invalid delivery person: ${targetPersonName}`);
      return;
    }

    const fullRows = detailRows.filter(r => draggedIds.has(r.id));

    const payload = {
      UsrName: username,
      SessId: "web",
      Dpid: targetDp.Dpid,
      Dhid: targetDp.Dhid,
      DpName: targetDp.DpName,
      Items: fullRows.map(row => ({
        SeqId: row.id,
        Slno: row.slno,
        Vcode: row.code,
        VName: row.customer,
        InvNo: row.invoice,
        InvDate: row.invDate,
        Nettotal: row.amount,
        CBalance: row.cBalance,
        Paymode: row.payMode,
        DpName: targetDp.DpName,
        DeliveryStatus: row.deliveryStatus || "Not Delivered",
        SelectItem: row.amount
      }))
    };

    try {
      await api.AllotDeliveryPersonAPI(payload);
      setDetailRows(prev =>
        prev.filter(row => !draggedIds.has(row.id))
      );

      setSummaryRows(prev => {
        const updated = prev.map(r => ({ ...r }));

        items.forEach(item => {
          if (!item.prevDeliveryPerson) return;

          const prevRow = updated.find(
            r => r.Dpname === item.prevDeliveryPerson
          );

          if (prevRow) {
            prevRow.NoOfBills -= 1;
            prevRow.TotalValue -= Number(item.value) || 0;
          }
        });

        let targetRow = updated.find(
          r => r.Dpname === targetPersonName
        );

        if (!targetRow) {
          targetRow = {
            Dhid: targetDp.Dhid,
            Slno: updated.length + 1,
            Dpname: targetPersonName,
            NoOfBills: 0,
            TotalValue: 0
          };
          updated.push(targetRow);
        }

        items.forEach(item => {
          targetRow.NoOfBills += 1;
          targetRow.TotalValue += Number(item.value) || 0;
        });

        return updated.filter(r => r.NoOfBills > 0);
      });

      setSelectedRows(new Set());

      showToastMessage(
        `Assigned ${items.length} bill(s) to ${targetPersonName}`
      );
    } catch (err) {
      console.error("AllotDeliveryPersonAPI error:", err);
      showToastMessage("Failed to assign bills");
    }
  };

  const handleOpenAction = async (Dhid) => {
    try {
      setDetailLoading(true);
      setDetailRows([]);

      const res = await api.GetBillCollectionAPI(Dhid);
      const data = res?.GetBillCollectionAPIjs?.Table || [];

      setDetailRows(
        data.map(row => ({
          id: row.SeqId,
          slno: row.Slno,
          code: row.Vcode,
          customer: row.VName,
          invoice: row.InvNo,
          invDate: row.InvDate,
          amount: Number(row.Nettotal) || 0,
          cBalance: Number(row.CBalance) || 0,
          payMode: row.Paymode,
          deliveryPerson: row.DpName,
          deliveryStatus: row.DeliveryStatus
        }))
      );
    } catch (err) {
      console.error("GetBillCollectionAPI error:", err);
    } finally {
      setDetailLoading(false);
    }
  };

  const buildSummaryFromDetails = (rows) => {
    const map = {};

    rows.forEach(r => {
      if (!r.deliveryPerson) return;

      if (!map[r.deliveryPerson]) {
        map[r.deliveryPerson] = {
          Dhid: 0,
          Slno: Object.keys(map).length + 1,
          Dpname: r.deliveryPerson,
          NoOfBills: 0,
          TotalValue: 0
        };
      }

      map[r.deliveryPerson].NoOfBills += 1;
      map[r.deliveryPerson].TotalValue += Number(r.amount) || 0;
    });

    return Object.values(map);
  };

  const buildPrintSummary = (rows) => {
    const map = {};

    rows.forEach(row => {
      if (!row.deliveryPerson) return;

      if (!map[row.deliveryPerson]) {
        map[row.deliveryPerson] = {
          deliveryPerson: row.deliveryPerson,
          billsCount: 0,
          totalValue: 0
        };
      }

      map[row.deliveryPerson].billsCount += 1;
      map[row.deliveryPerson].totalValue += Number(row.amount) || 0;
    });

    return Object.values(map).map((x, i) => ({
      slNo: i + 1,
      deliveryPerson: x.deliveryPerson,
      billsCount: x.billsCount,
      totalValue: x.totalValue
    }));
  };

  const handleApplyAllotment = async () => {
    if (!filterDeliveryPerson) {
      alert("Select Delivery Person");
      return;
    }

    const dp = deliveryPersons.find(
      p => p.DpName === filterDeliveryPerson
    );

    if (!dp) {
      alert("Invalid Delivery Person");
      return;
    }

    if (selectedRows.size === 0) {
      alert("Select at least one bill");
      return;
    }

    const selectedItems = detailRows.filter(r =>
      selectedRows.has(r.id)
    );

    const payload = {
      UsrName: username,
      SessId: "web",
      Dpid: dp.Dpid,
      Dhid: dp.Dhid,
      DpName: dp.DpName,
      Items: selectedItems.map(row => ({
        SeqId: row.id,
        Slno: row.slno,
        Vcode: row.code,
        VName: row.customer,
        InvNo: row.invoice,
        InvDate: row.invDate,
        Nettotal: row.amount,
        CBalance: row.cBalance,
        Paymode: row.payMode,
        DpName: dp.DpName,
        DeliveryStatus: row.deliveryStatus || "Not Delivered",
        SelectItem: row.amount
      }))
    };

    try {
      await api.AllotDeliveryPersonAPI(payload);

      const selectedIds = new Set(selectedItems.map(i => i.id));

      const remainingDetails = detailRows.filter(
        row => !selectedIds.has(row.id)
      );

      setDetailRows(remainingDetails);
      setSummaryRows(prev => {
        const updated = prev.map(r => ({ ...r }));
        selectedItems.forEach(item => {
          if (!item.deliveryPerson) return;

          const prevRow = updated.find(r => r.Dpname === item.deliveryPerson);
          if (prevRow) {
            prevRow.NoOfBills -= 1;
            prevRow.TotalValue -= item.amount;
          }
        });

        let targetRow = updated.find(r => r.Dpname === dp.DpName);

        if (!targetRow) {
          targetRow = {
            Dhid: dp.Dhid,
            Slno: updated.length + 1,
            Dpname: dp.DpName,
            NoOfBills: 0,
            TotalValue: 0
          };
          updated.push(targetRow);
        }

        selectedItems.forEach(item => {
          targetRow.NoOfBills += 1;
          targetRow.TotalValue += item.amount;
        });

        return updated.filter(r => r.NoOfBills > 0);
      });

      setSelectedRows(new Set());
      setAppliedFilterPerson("");

      showToastMessage("Bills allotted successfully");
    } catch (err) {
      console.error("AllotDeliveryPersonAPI error:", err);
      alert("Failed to allot delivery person");
    }

  };

  const getTotalValue = (personName) => {
    const bills = assignedBills[personName] || [];
    return bills.reduce((sum, b) => sum + b.amount, 0);
  };

  const getBillCount = (personName) => {
    return assignedBills[personName]?.length || 0;
  };

  const handleKeyDownReportType = (e) => {
    const options = reportTypes.filter(rt =>
      rt.ReportTitle.toLowerCase().includes(reportSearch.toLowerCase())
    );
    if (!showReportDropdown && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setShowReportDropdown(true);
      setActiveIndexReportType(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexReportType(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexReportType(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (showReportDropdown && activeIndexReportType >= 0) {
          e.preventDefault();
          const selected = options[activeIndexReportType];
          if (selected) {
            setSelectedReportType(selected.ReportTitle);
            setReportSearch(selected.ReportTitle);
            setShowReportDropdown(false);
            setActiveIndexReportType(-1);
          }
        }
        break;
      case "Escape":
        setShowReportDropdown(false);
        setActiveIndexReportType(-1);
        break;
      default:
        break;
    }
  };

  const handleKeyDownItemType = (e) => {
    const options = itemTypes.filter(it =>
      it.ItemType.toLowerCase().includes(itemSearch.toLowerCase())
    );
    if (!showItemDropdown && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setShowItemDropdown(true);
      setActiveIndexItemType(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexItemType(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexItemType(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (showItemDropdown && activeIndexItemType >= 0) {
          e.preventDefault();
          const selected = options[activeIndexItemType];
          if (selected) {
            setSelectedItemType(selected.ItemType);
            setItemSearch(selected.ItemType);
            setShowItemDropdown(false);
            setActiveIndexItemType(-1);
          }
        }
        break;
      case "Escape":
        setShowItemDropdown(false);
        setActiveIndexItemType(-1);
        break;
      default:
        break;
    }
  };

  const handleKeyDownDeliveryPerson = (e) => {
    const options = deliveryPersons.filter(dp =>
      dp.DpName.toLowerCase().includes(deliverySearch.toLowerCase())
    );
    if (!showDpDropdown && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setShowDpDropdown(true);
      setActiveIndexDeliveryPerson(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexDeliveryPerson(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexDeliveryPerson(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (showDpDropdown && activeIndexDeliveryPerson >= 0) {
          e.preventDefault();
          const selected = options[activeIndexDeliveryPerson];
          if (selected) {
            setFilterDeliveryPerson(selected.DpName);
            setDeliverySearch(selected.DpName);
            setShowDpDropdown(false);
            setActiveIndexDeliveryPerson(-1);
          }
        }
        break;
      case "Escape":
        setShowDpDropdown(false);
        setActiveIndexDeliveryPerson(-1);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Header onLogout={handleLogout} />
      <div className="p-3 bg-gray-50 min-h-screen md:ml-64" style={{ fontFamily: "'Inter', sans-serif" }}>
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={() => navigate('/dashboard')}
              className="inline-flex items-center justify-center px-3 py-1 font-semibold text-gray-800 transition bg-gray-200 rounded-full shadow-md hover:bg-gray-300"
            >
              ← Back
            </button>

            <h2 className="text-2xl font-bold text-orange-600 text-center flex-1">
              Delivery Allotment
            </h2>
          </div>

          <div className="bg-white rounded-lg shadow p-1 mb-2">
            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4 items-end">
              <div className="flex flex-col gap-1">
                <label className="text-sm font-bold text-orange-600">Date</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-orange-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                  value={actionDate}
                  onChange={(e) => setActionDate(e.target.value)}
                />

              </div>
              {/* Report Type Search Dropdown */}
<div className="flex flex-col gap-1 relative">
  <label className="text-sm font-bold text-orange-600">
    Report Type
  </label>

  <input
    type="text"
    placeholder="Search Report Type"
    value={reportSearch}
    onFocus={() => setShowReportDropdown(true)}
    onChange={(e) => {
      setReportSearch(e.target.value);
      setSelectedReportType("");
      setShowReportDropdown(true);
      setActiveIndexReportType(-1);
    }}
    onBlur={() => setTimeout(() => setShowReportDropdown(false), 150)}
    onKeyDown={handleKeyDownReportType}
    className="w-full px-3 py-2 border border-orange-300 rounded-lg
               focus:outline-none focus:ring-2 focus:ring-orange-500"
  />

  {showReportDropdown && (
    <div ref={listRefReportType} className="absolute top-full mt-1 w-full bg-white border border-orange-300 rounded-lg shadow-lg max-h-40 overflow-y-auto z-50">
      {reportTypes
        .filter(rt =>
          rt.ReportTitle.toLowerCase().includes(reportSearch.toLowerCase())
        )
        .map((rt, index) => (
          <div
            key={index}
            onClick={() => {
              setSelectedReportType(rt.ReportTitle);
              setReportSearch(rt.ReportTitle);
              setShowReportDropdown(false);
              setActiveIndexReportType(-1);
            }}
            onMouseEnter={() => setActiveIndexReportType(index)}
            className={`px-3 py-2 cursor-pointer ${
              index === activeIndexReportType
                ? "bg-gray-100 font-semibold"
                : "hover:bg-orange-100"
            } text-sm`}
          >
            {rt.ReportTitle}
          </div>
        ))}

      {reportTypes.filter(rt =>
        rt.ReportTitle.toLowerCase().includes(reportSearch.toLowerCase())
      ).length === 0 && (
        <div className="px-3 py-2 text-gray-400 text-sm italic">
          No match found
        </div>
      )}
    </div>
  )}
</div>

              {/* Item Type Search Dropdown */}
<div className="flex flex-col gap-1 relative">
  <label className="text-sm font-bold text-orange-600">
    Item Type
  </label>

  <input
    type="text"
    placeholder="Search Item Type"
    value={itemSearch}
    onFocus={() => setShowItemDropdown(true)}
    onChange={(e) => {
      setItemSearch(e.target.value);
      setSelectedItemType("");
      setShowItemDropdown(true);
      setActiveIndexItemType(-1);
    }}
    onBlur={() => setTimeout(() => setShowItemDropdown(false), 150)}
    onKeyDown={handleKeyDownItemType}
    className="w-full px-3 py-2 border border-orange-300 rounded-lg
               focus:outline-none focus:ring-2 focus:ring-orange-500"
  />

  {showItemDropdown && (
    <div ref={listRefItemType} className="absolute top-full mt-1 w-full bg-white border border-orange-300 rounded-lg shadow-lg max-h-40 overflow-y-auto z-50">
      {itemTypes
        .filter(it =>
          it.ItemType.toLowerCase().includes(itemSearch.toLowerCase())
        )
        .map((it, index) => (
          <div
            key={index}
            onClick={() => {
              setSelectedItemType(it.ItemType);
              setItemSearch(it.ItemType);
              setShowItemDropdown(false);
              setActiveIndexItemType(-1);
            }}
            onMouseEnter={() => setActiveIndexItemType(index)}
            className={`px-3 py-2 cursor-pointer ${
              index === activeIndexItemType
                ? "bg-gray-100 font-semibold"
                : "hover:bg-orange-100"
            } text-sm`}
          >
            {it.ItemType}
          </div>
        ))}

      {itemTypes.filter(it =>
        it.ItemType.toLowerCase().includes(itemSearch.toLowerCase())
      ).length === 0 && (
        <div className="px-3 py-2 text-gray-400 text-sm italic">
          No match found
        </div>
      )}
    </div>
  )}
</div>


              <div className="flex gap-2 lg:col-span-2">
                <button
                  onClick={handleRefresh}
                  className="bg-orange-500 text-white px-2 py-[2px] rounded-full hover:bg-orange-600 transition text-s font-semibold"

                >
                  Refresh
                </button>

                {/* <button className="flex-1 bg-orange-600 border border-orange-200 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-orange-700 transition shadow-lg flex items-center justify-center gap-2 uppercase">
                <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                Preview
              </button> */}
              </div>
            </div>
          </div>

          {/* Summary Table */}
          <div className="overflow-x-auto p-1 mb-6">
            <table className="min-w-[700px] w-full table-fixed bg-white border-gray-300 rounded-2xl shadow-lg overflow-hidden text-xs">

              <thead className="bg-orange-500 text-white">
                <tr>
                  <th className="px-3 py-2 text-center border-b whitespace-nowrap w-[80px]">
                    Print View
                  </th>
                  <th className="px-3 py-2 text-center border-b whitespace-nowrap">
                    Sl. No.
                  </th>
                  <th className="px-3 py-2 text-left border-b whitespace-nowrap">
                    Delivery Person
                  </th>
                  <th className="px-3 py-2 text-right border-b whitespace-nowrap">
                    Bills Count
                  </th>
                  <th className="px-3 py-2 text-right border-b whitespace-nowrap">
                    Total Value
                  </th>
                  <th className="px-3 py-2 text-center border-b whitespace-nowrap w-[70px]">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {summaryRows.map((row, index) => (
                  <tr
                    key={row.Dhid}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => handleDrop(e, row.Dpname)}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-3 py-2 border-b text-center whitespace-nowrap w-[120px]">
                      <button
                        onClick={() => {
                          setPrintPerson(row.Dpname);
                          setShowPrintModal(true);
                        }}
                        className="bg-orange-500 text-white px-2 py-[2px] rounded-full hover:bg-orange-600 transition text-xs font-semibold"

                      >
                        Print
                      </button>
                    </td>

                    <td className="px-3 py-2 border-b text-s text-center whitespace-nowrap">
                      {row.Slno}
                    </td>

                    <td className="px-3 py-2 border-b text-s whitespace-nowrap">
                      {row.Dpname}
                    </td>

                    <td className="px-3 py-2 border-b text-right whitespace-nowrap">
                      {row.NoOfBills}
                    </td>

                    <td className="px-3 py-2 border-b text-right whitespace-nowrap">
                      {formatAmount(row.TotalValue)}
                    </td>

                    <td className="px-3 py-2 border-b text-center whitespace-nowrap w-[100px]">
                      <button
                        onClick={() => handleOpenAction(row.Dhid)}
                        className="bg-orange-500 text-white px-2 py-[2px] rounded-full hover:bg-orange-600 transition text-xs font-semibold"

                      >
                        List
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {summaryRows.length === 0 && (
              <div className="p-6 text-center text-gray-500 italic">
                No delivery persons found.
              </div>
            )}
          </div>


          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 w-full mb-6">

            {/* Search Label + Input */}
            <div className="flex flex-col gap-1">
              <label className="text-sm font-bold text-orange-600">
                Search
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-orange-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                placeholder="Customer / Invoice"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Delivery Person Dropdown */}
          {/* Delivery Person Search Dropdown */}
<div className="flex flex-col gap-1 relative">
  <label className="text-sm font-bold text-orange-600">
    Delivery Person
  </label>

  <input
  type="text"
  placeholder="Search Delivery Person"
  value={deliverySearch}
  onFocus={() => setShowDpDropdown(true)}
  onChange={(e) => {
    setDeliverySearch(e.target.value);
    setFilterDeliveryPerson("");
    setShowDpDropdown(true);
    setActiveIndexDeliveryPerson(-1);
  }}
  onBlur={() => {
    // Delay needed so click works
    setTimeout(() => setShowDpDropdown(false), 150);
  }}
  onKeyDown={handleKeyDownDeliveryPerson}
  className="w-full px-3 py-2 border border-orange-300 rounded-lg
             focus:outline-none focus:ring-2 focus:ring-orange-500"
/>

  {/* Dropdown list */}
  {showDpDropdown && (
    <div ref={listRefDeliveryPerson} className="absolute top-full mt-1 w-full bg-white border border-orange-300 rounded-lg shadow-lg max-h-40 overflow-y-auto z-50">
      {deliveryPersons
        .filter(dp =>
          dp.DpName.toLowerCase().includes(deliverySearch.toLowerCase())
        )
        .map((dp, index) => (
          <div
            key={dp.Dhid}
            onClick={() => {
              setFilterDeliveryPerson(dp.DpName);
              setDeliverySearch(dp.DpName);
              setShowDpDropdown(false);
              setActiveIndexDeliveryPerson(-1);
            }}
            onMouseEnter={() => setActiveIndexDeliveryPerson(index)}
            className={`px-3 py-2 cursor-pointer ${
              index === activeIndexDeliveryPerson
                ? "bg-gray-100 font-semibold"
                : "hover:bg-orange-100"
            } text-sm`}
          >
            {dp.DpName}
          </div>
        ))}

      {deliveryPersons.filter(dp =>
        dp.DpName.toLowerCase().includes(deliverySearch.toLowerCase())
      ).length === 0 && (
        <div className="px-3 py-2 text-gray-400 text-sm italic">
          No match found
        </div>
      )}
    </div>
  )}
</div>


            {/* Apply Button */}
            <div className="flex items-end">
              <button
                onClick={() => {
                  if (!filterDeliveryPerson) {
                    alert("Select Delivery Person");
                    return;
                  }
                  
                  if (selectedRows.size === 0) {
                    alert("Select at least one bill");
                    return;
                  }

                  // ✅ Apply filter ONLY when allotment is valid
                  setAppliedFilterPerson(filterDeliveryPerson);
                  handleApplyAllotment();
                }}
                className="bg-orange-500 text-white px-2 py-1 rounded-full"
              >
                Apply
              </button>
               <button
    onClick={exportToCSV}
    className="
      px-2.5 py-1.5
      text-sm font-semibold
      inline-flex items-center
      bg-blue-500 text-white
      rounded-full
      hover:bg-blue-700
      shadow
      transition
      whitespace-nowrap
    "
  >
    📄 Export
  </button>
            </div>
          </div>

          {/* Detail List */}
          <div className="overflow-x-auto p-1 mb-2">
            <table className="min-w-[900px] w-full table-fixed bg-white border-gray-300 rounded-2xl shadow-lg overflow-hidden text-xs">

              <div className="flex items-center justify-between mb-2">
                <h2 className="text-lg font-bold text-orange-800">Detail List</h2>
                <div className="flex items-center gap-2 text-xs font-bold text-orange-700 uppercase">
                  <input type="checkbox" id="selectAllDetail" className="w-4 h-4 accent-orange-600" checked={selectedRows.size === filteredRows.length && filteredRows.length > 0} onChange={(e) => handleSelectAll(e.target.checked)} />
                  <label htmlFor="selectAllDetail" className="cursor-pointer">Select All</label>
                </div>
              </div>
              <table className="min-w-full bg-white border-gray-300 rounded-2xl shadow-lg overflow-hidden">
                <thead className="bg-orange-500 text-white">
                  <tr>
                    <th className="px-2 py-2 text-center border-b">Sl.No</th>
                    <th className="px-2 py-2 text-left border-b">Code</th>
                    <th className="px-2 py-2 text-left border-b">Customer</th>
                    <th className="px-2 py-2 text-left border-b">Inv No</th>
                    <th className="px-2 py-2 text-left border-b">Inv Date</th>
                    <th className="px-2 py-2 text-right border-b">Net Total</th>
                    <th className="px-2 py-2 text-right border-b">C Balance</th>
                    <th className="px-2 py-2 text-left border-b">Pay Mode</th>
                    <th className="px-2 py-2 text-left border-b">Delivery Person</th>
                    <th className="px-2 py-2 text-center border-b">Select</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.map((row, index) => (
                    <tr
                      key={row.id}
                      draggable
                      onDragStart={(e) => handleDragStart(e, row)}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      style={{ cursor: "grab" }}
                    >
                      <td className="px-2 py-2 border-b text-black text-center">{index + 1}</td>
                      <td className="px-2 py-2 border-b text-black font-mono">{row.code}</td>
                      <td className="px-2 py-2 border-b text-black">{row.customer}</td>
                      <td className="px-2 py-2 border-b text-black">{row.invoice}</td>
                      <td className="px-2 py-2 border-b text-black">{row.invDate}</td>
                      <td className="px-2 py-2 border-b text-black text-right">₹{formatAmount(row.amount)}</td>
                      <td className="px-2 py-2 border-b text-black text-right">  ₹{formatAmount(row.cBalance)}</td>
                      <td className="px-2 py-2 border-b text-black">
                        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">{row.payMode}</span>
                      </td>
                      <td className="px-2 py-2 border-b text-black">{row.deliveryPerson}</td>
                      <td className="px-2 py-2 border-b text-center">
                        <input
                          type="checkbox"
                          className="w-4 h-4 accent-orange-600"
                          checked={selectedRows.has(row.id)}
                          onChange={(e) => handleRowCheckbox(row.id, e.target.checked)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {detailLoading ? (
                <div className="p-12 text-center text-black font-semibold">Loading bills, please wait...</div>
              ) : filteredRows.length === 0 ? (
                <div className="p-12 text-center text-gray-500 italic">No matching bills found.</div>
              ) : null}
            </table>
          </div>
        </div>

        {/* Bill Preview Modal */}
        {modalOpen && (
          <div id="billModal" className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50" style={{ display: "flex" }}>
            <div className="modal-content bg-white w-full max-w-lg border border-orange-200 rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-300 scale-100">
              <div className="p-3 border-b border-orange-100 flex justify-between items-center bg-orange-600">
                <div>
                  <h3 id="modalTitle" className="text-lg font-bold text-white uppercase tracking-wider">Bills Assigned</h3>
                  <p id="modalSubtitle" className="text-xs text-orange-100 font-bold uppercase">{assignedBills[currentModalPerson]?.length || 0} BILLS ASSIGNED</p>
                </div>
                <button onClick={closeBillModal} className="text-white hover:text-orange-200 bg-orange-600 w-8 h-8 rounded-full flex items-center justify-center shadow-lg transition">✕</button>
              </div>
              <div className="p-3 max-h-60 overflow-y-auto bg-white">
                <table className="w-full text-left text-sm">
                  <thead className="text-orange-500 uppercase text-xs font-bold">
                    <tr>
                      <th className="pb-2">Inv No</th>
                      <th className="pb-2">Customer</th>
                      <th className="pb-2 text-right">Amount</th>
                      <th className="pb-2 text-center w-24">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedBills[currentModalPerson]?.map((bill, index) => (
                      <tr key={index} className="hover:bg-orange-50 group">
                        <td className="py-4 font-mono text-orange-600 font-black text-xs">{bill.id}</td>
                        <td className="py-4 font-bold text-slate-700 text-xs">{bill.customer}</td>
                        <td className="py-4 text-right font-black text-slate-900 text-xs">
                          ₹{formatAmount(bill.amount)}
                        </td>

                        <td className="py-4 text-center">
                          <button onClick={() => reverseAssignment(currentModalPerson, index)} className="bg-red-50 text-red-600 border border-red-200 px-3 py-1 rounded text-xs font-black hover:bg-red-600 hover:text-white transition uppercase shadow-sm">
                            Reverse
                          </button>
                        </td>
                      </tr>
                    )) || (
                        <tr>
                          <td colSpan="4" className="py-12 text-center text-orange-300 italic text-xs font-bold">No assignments currently</td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>
              <div className="p-3 bg-orange-50 flex justify-end gap-2">
                <button onClick={closeBillModal} className="bg-orange-600 text-white px-8 py-2 rounded-lg text-xs font-bold uppercase hover:bg-orange-700 shadow-lg transition">Close</button>
              </div>
            </div>
          </div>
        )}

        {/* Print Preview Modal */}
        {showPrintModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50">
            <div className="modal-content bg-white w-full max-w-4xl border border-orange-200 rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-300 scale-100">
              <div className="p-4 border-b border-orange-100 flex justify-between items-center bg-orange-600">
                <div>
                  <h3 className="text-lg font-bold text-white uppercase tracking-wider">Print Preview - {printPerson}</h3>
                  <p className="text-xs text-orange-100 font-bold uppercase">{getCurrentDate()}</p>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => window.print()} className="bg-white text-orange-600 px-2 py-1 rounded-lg text-sm font-semibold hover:bg-orange-50 transition shadow-lg uppercase">Print</button>
                  <button onClick={() => setShowPrintModal(false)} className="text-white hover:text-orange-200 bg-orange-700 w-8 h-8 rounded-full flex items-center justify-center shadow-lg transition">✕</button>
                </div>
              </div>
              <div className="p-6 bg-white">
                <div className="mb-6">
                  <h4 className="text-xl font-bold text-orange-800 mb-4">Bills Assigned to {printPerson}</h4>
                  <table className="w-full border-collapse border border-orange-200">
                    <thead>
                      <tr className="bg-orange-50">
                        <th className="border border-orange-200 p-2 text-left text-xs font-bold text-orange-900 uppercase">Inv No</th>
                        <th className="border border-orange-200 p-2 text-left text-xs font-bold text-orange-900 uppercase">Customer</th>
                        <th className="border border-orange-200 p-2 text-right text-xs font-bold text-orange-900 uppercase">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedBills[printPerson]?.map((bill, index) => (
                        <tr key={index}>
                          <td className="border border-orange-200 p-2 font-mono text-orange-600 font-black text-xs">{bill.id}</td>
                          <td className="border border-orange-200 p-2 font-bold text-slate-700">{bill.customer}</td>
                          <td className="border border-orange-200 p-2 text-right font-black text-slate-900">
                            ₹{formatAmount(bill.amount)}
                          </td>

                        </tr>
                      )) || (
                          <tr>
                            <td colSpan="3" className="border border-orange-200 p-2 text-center text-orange-300 italic">No bills assigned</td>
                          </tr>
                        )}
                    </tbody>
                    <tfoot>
                      <tr className="bg-orange-100">
                        <td colSpan="2" className="border border-orange-200 p-2 text-center font-bold text-orange-900">Total</td>
                        <td className="border border-orange-200 p-2 text-right font-black text-slate-900">
                          ₹{formatAmount(getTotalValue(printPerson))}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="p-4 bg-orange-50 flex justify-end gap-2">
                <button onClick={() => setShowPrintModal(false)} className="bg-orange-600 text-white px-8 py-2 rounded-lg text-xs font-bold uppercase hover:bg-orange-700 shadow-lg transition">Close</button>
              </div>
            </div>
          </div>
        )}

        {showToast && (
          <div id="toast" className="fixed bottom-4 right-4 bg-orange-900 text-white p-3 rounded-xl shadow-2xl z-50 font-bold uppercase text-xs tracking-widest transform transition-all duration-300">
            {toastMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryAllotment;